import { useTranslations } from 'next-intl';
import React from 'react';

import { FormattedMessage } from '@flipster/i18n';
import { TextButton } from '@flipster/react/design-system/text-button';
import ChevronRightIcon from '@flipster/react/icon/generated/ChevronRightIcon';
import { css } from '@flipster/styled-system/css';
import { circle, hstack, stack } from '@flipster/styled-system/patterns';

export const HowToRedeem = () => {
  const t = useTranslations();
  return (
    <div className={css({ mb: 12 })}>
      <div>
        <details
          className={css({
            color: 'content.default.level-5',
            borderBottom: '1px solid {colors.border.default.level-1}',
          })}
        >
          <summary
            className={css({
              py: 12,
              display: 'flex',
              justifyContent: 'space-between',
              textStyle: 'Text/M/Strong',
            })}
          >
            <p>
              <FormattedMessage id='Autogen_common.r251126.s_How_to_redeem_a_share_of_the_launchpool_with_your_Sparks' />
            </p>
            <ChevronRightIcon
              size={20}
              className={css({
                transform: 'rotate(90deg)',
                transition: 'transform 0.2s',
                '[open] &': { transform: 'rotate(-90deg)' },
              })}
            />
          </summary>
          <ul className={stack({ mt: 4, mb: 12, gap: 16, textStyle: 'Text/M/Regular' })}>
            <ListItem n={1}>
              Rack up{' '}
              <TextButton
                as='a'
                label={t('Autogen_common.r251126.s_Sparks')}
                href='/spark/reward'
                css={{ verticalAlign: 'middle' }}
              />{' '}
              by trading and depositing
            </ListItem>
            <ListItem n={2}>
              <FormattedMessage id='Autogen_common.r251126.s_Join_the_Launchpool_and_input_the_amount_of_Sparks_you_want_to_spend' />
            </ListItem>
            <ListItem n={3}>
              <FormattedMessage id='Autogen_common.r251126.s_The_larger_the_amount_of_Sparks_you_use_the_larger_the_share_of_the_Launchpool_you_get' />
            </ListItem>
          </ul>
        </details>
      </div>
      <p className={css({ mt: 12, color: 'content.state.warning', textStyle: 'Text/M/Regular' })}>
        <FormattedMessage id='Autogen_common.r251126.s_Sparks_used_will_not_be_returned' />
      </p>
    </div>
  );
};

interface ListItemProps extends React.PropsWithChildren {
  n: number;
}
const ListItem = ({ n, children }: ListItemProps) => {
  return (
    <li className={hstack({ gap: 10 })}>
      <span
        className={circle({
          width: 24,
          height: 24,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          textStyle: 'Text/S/Strong',
          bg: 'background.default.level-3',
        })}
      >
        {n}
      </span>
      <span>{children}</span>
    </li>
  );
};
